export default __webpack_public_path__ + "static/media/quick-invest-icon.4b2ae501.svg";